import { render, staticRenderFns } from "./fixedPosition.vue?vue&type=template&id=b9ceec80&scoped=true"
import script from "./fixedPosition.vue?vue&type=script&lang=js"
export * from "./fixedPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ceec80",
  null
  
)

export default component.exports